module.exports = __webpack_public_path__ + "img/r-76.f92c05da.jpg";